var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-container"},_vm._l((_vm.toastList),function(toast){return _c('BottomRightToastItem',{key:toast.id,attrs:{"toast":toast}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }